import { metadata } from '@atlaskit/object/metadata';

import { getObjectName } from './get-object-name';
import { type ObjectData, type ObjectTileData } from './types';

// use this to cache the result
let objectsPromise: Promise<Record<string, ObjectData> | undefined> | null = null;

// get object info as a Promise which returns a Record
export const getObjects: () => Promise<Record<string, ObjectData> | undefined> = () => {
	if (!objectsPromise) {
		objectsPromise = Promise.all(
			Object.entries(metadata).map(async ([name, meta]) => {
				const object = await meta.object.packageLoader();
				return { name, object: object.default, meta };
			}),
		)
			.then((newData) =>
				newData
					.map((object) => {
						return {
							[object.name]: {
								keywords: object.meta.keywords,
								component: object.object,
								componentName: object.meta.object.componentName,
								packageName: object.meta.object.package,
								objectName: getObjectName(object.name),
								color: object.meta.color,
								icon: object.meta.icon,
								iconPackage: object.meta.iconPackage,
							} as ObjectData,
						};
					})
					.reduce((acc, b) => ({ ...acc, ...b })),
			)
			.catch(() => {
				return undefined;
			});
	}

	return objectsPromise;
};

// use this to cache the result
let objectTilesPromise: Promise<Record<string, ObjectTileData> | undefined> | null = null;

// get object tile info as a Promise which returns a Record
export const getObjectTiles: () => Promise<Record<string, ObjectTileData> | undefined> = () => {
	if (!objectTilesPromise) {
		objectTilesPromise = Promise.all(
			Object.entries(metadata).map(async ([name, meta]) => {
				const objectTile = await meta.tile.packageLoader();
				return { name, objectTile: objectTile.default, meta };
			}),
		)
			.then((newData) =>
				newData
					.map((objectTile) => {
						return {
							[objectTile.name]: {
								keywords: [...objectTile.meta.keywords, 'tile'],
								component: objectTile.objectTile,
								componentName: objectTile.meta.tile.componentName,
								packageName: objectTile.meta.tile.package,
								objectName: getObjectName(objectTile.name),
								color: objectTile.meta.color,
								icon: objectTile.meta.icon,
								iconPackage: objectTile.meta.iconPackage,
							} as ObjectTileData,
						};
					})
					.reduce((acc, b) => ({ ...acc, ...b })),
			)
			.catch(() => {
				return undefined;
			});
	}

	return objectTilesPromise;
};
